import {useSelector} from 'react-redux';

export const useErrors = ()=> useSelector(({errors})=>errors);
export const useError = (id) => useErrors()[id];